module.exports = "/_next/static/images/toybox-open-fac4c8d5c61d3435be8d442d78421556.svg";